(function () {
  SUGApp.controller("homeController", ["$scope", "loginfactory",
    function ($scope, loginfactory) {
      // create an instance of the login service
      $scope.login = loginfactory.getLogin(false, true);
    },
  ]);
})();
